import { api } from '@/api';

export interface GetLevelUpSuggestionsResponse {
  levelUpSuggestions: string[];
}

const getLevelUpSuggestionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLevelUpSuggestions: builder.query<GetLevelUpSuggestionsResponse, void>({
      query: () => ({
        url: '/chat/level-up-suggestions',
        method: 'GET',
      }),
    }),
  }),
});

export const { useLazyGetLevelUpSuggestionsQuery } = getLevelUpSuggestionsApi;
